export default {
    categoryCourses: [],
  };